import { render } from "./receiptList.vue?vue&type=template&id=5723442f&scoped=true"
import script from "./receiptList.vue?vue&type=script&lang=js"
export * from "./receiptList.vue?vue&type=script&lang=js"

import "./receiptList.vue?vue&type=style&index=0&id=5723442f&scoped=true&lang=css"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5723442f"]])

export default __exports__